export default __webpack_public_path__ + "static/media/kaffeehaus-aussen.dcbc76ac.jpg";